export default "__VITE_ASSET__CV5oXYJ4__"